<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import TextBox from "../../../../compositions/TextBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const listHeight = ref(0);
const headerRef = ref();
const submitRef = ref();
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - document.getElementById('order_header').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEditedCheck()) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}
const { isVisible,identityId } = toRefs(props);
const listOrderWaitRef = ref();
const searchWord = ref('');
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_detail_name', width: '22%', align: 'text-left', sorted:true},
  {field_name: '分類', field_key: 'warning_mark', width: '6%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'order_target_type', width: '5%', align: 'text-center'},
  {field_name: '発注先', field_key: 'order_target', width: '15%', align: 'text-left', sorted:true},
  {field_name: '伝票番号', field_key: 'slip_number', width: '10%', align: 'text-left', sorted:true},
  {field_name: '伝票情報', field_key: 'slip_info', width: '19%', align: 'text-left', sorted:false},
  {field_name: '発注数', field_key: 'ordered_number', width: '10%', align: 'text-center'},
  {field_name: '発注日時', field_key: 'order_date', width: '15%', align: 'text-center', sorted:true},
  {field_name: '納品日', field_key: 'delivery_date', width: '10%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_wait', width: '8%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_wait' : 1,
  'wholesaler_id':null,
});
const listSearch = (force = false,delay=0) => {
  orderOptionFields.search_word = searchWord.value;
  orderOptionFields.wholesaler_id = selectWholesalerId.value ? selectWholesalerId.value : null;
  if (force == false) {
    listOrderWaitRef.value.resetItem(delay);
  } else {
    listOrderWaitRef.value.resetForceItem(delay);
  }
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const editTransactionStatusChange = (identityId,status,reserveCount) => {
  let item = listOrderWaitRef.value.getItemById(identityId,'id');
  if (reserveCount == 0) {
    listOrderWaitRef.value.deleteItem(item);
    order.delete_data('is_wait',identityId);
    order.order_wait_count--;
  } else {
    if (item.stock_type == 1) { //VAN
      item.lot_number = reserveCount;
    } else { //小分け
      item.number = reserveCount;
    }
    listOrderWaitRef.value.updateItem(item);
  }
  if (status == 0) {
    order.order_defect_count++;
  } else {
    order.order_today_count++;
  }
}
const onCheckChange = (values) => {
  order.edit_wait_data = values;
}
const editSettingComplete = () => {
  listSearch(false,config.LIST_DELAY);
}
const isLoadingDialog = ref(false);
const updatePharmacyStocksTransactionStatusConfirm = async () => {
  if (getEstablishList().length > 0) {
    isEstablishFileDialog.value = true;
  } else {
    updatePharmacyStocksTransactionStatus();
  }
}
const updatePharmacyStocksTransactionStatus = async () => {
  let errorFlg = false;
  //2024/01/24 TODO 開設許可書の必須条件を削除
  for (let i=0;i<establishFiles.length;i++) {
    //どれか一つで入っている場合は全てを必須にする
    if ((establishFiles[i].file != null) ||
        (establishFiles[i].number != null && establishFiles[i].number.length > 0) ||
        (establishFiles[i].expire_date != null && establishFiles[i].expire_date.length > 0)) {
      if (establishFiles[i].file == null) {
        errorAlert('開設許可証を選択してください。');
        errorFlg = true;
        break;
      }
      if (establishFiles[i].number == '') {
        errorAlert('開設許可証番号を入力してください。');
        errorFlg = true;
        break;
      }
      if (establishFiles[i].expire_date == '') {
        errorAlert('有効期限を入力してください。');
        errorFlg = true;
        break;
      }
    }
  }
  if (errorFlg) {
    return;
  }
  let params = new FormData();
  for (let i=0;i<establishFiles.length;i++) {
    params.append('file_ids', establishFiles[i].id);
    params.append('establish_permit_number_' + establishFiles[i].id, establishFiles[i].number);
    params.append('establish_permit_expire_date_' + establishFiles[i].id, establishFiles[i].expire_date);
    params.append('establish_permit_file_' + establishFiles[i].id, establishFiles[i].file);
  }
  for (let i=0;i<order.edit_wait_data.length;i++) {
    params.append('stock_ids', order.edit_wait_data[i]);
  }
  params.append('status', 1);
  params.append('defect_number', 0);
  isLoadingDialog.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update_transaction_status,{method:"post",data:params});
    if (response.data.status == 200) {
      order.order_today_count += response.data.data;
      order.reset_data('is_wait');
      closeEstablishFileDialog();
      listSearch(false,config.LIST_DELAY);
    }
  } finally {
    isLoadingDialog.value = false;
  }
}

watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    listSearch();
    setTimeout(changeListHeight,100);
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})

const domComplete = () => {
  order.order_wait_count = listOrderWaitRef.value.getItemAllCount();
}
const isEditedCheck = () => {
  return (order.edit_wait_data.length > 0 ? true : false);
}
const isEdited = computed(() => {
  setTimeout(changeListHeight,100);
  return isEditedCheck();
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
})
onMounted(() => {
  listSearch();
  window.addEventListener('resize', changeListHeight);
  setTimeout(changeListHeight,100);
});
const getEstablishList = () => {
  if (typeof listOrderWaitRef.value === 'undefined') {
    return [];
  }
  let result = [];
  let items = listOrderWaitRef.value.getItems();
  for (let i=0;i<items.length;i++) {
    if (order.edit_wait_data.indexOf(items[i].id) != -1 && items[i].pharmacy_pack != null && (items[i].pharmacy_pack.to_pharmacy.establish_permit_upload_date == null || items[i].pharmacy_pack.to_pharmacy.is_establish_permit_expired == true)) {
      result.push(items[i]);
    }
  }
  return result;
}
const establishUploadList = computed(() => {
  return getEstablishList();
});
const establishUploadNumber = computed(() => {
  return (stockId) => {
    let result = '';
    for (let i=0;i<establishFiles.length;i++) {
      if (establishFiles[i].id == stockId) {
        result = establishFiles[i].number;
        break;
      }
    }
    return result;
  }
})
const establishUploadExpireDate = computed(() => {
  return (stockId) => {
    let result = '';
    for (let i=0;i<establishFiles.length;i++) {
      if (establishFiles[i].id == stockId) {
        result = establishFiles[i].expire_date;
        break;
      }
    }
    return result;
  }
})
const isEstablishFileDialog = ref(false);
const establishFiles = reactive([]);
const inputEstablishFiles = ref();
const onFileUpload = (e,stockId) => {
  let exists = false;
  for (let i=0;i<establishFiles.length;i++) {
    if (establishFiles[i].id == stockId) {
      establishFiles[i].file = e.target.files[0];
      exists = true;
      break;
    }
  }
  if (exists == false) {
    establishFiles.push({
      id:stockId,
      number:'',
      expire_date:'',
      file:e.target.files[0],
    });
  }
}
const onTextChange = (value,options) => {
  let exists = false;
  for (let i=0;i<establishFiles.length;i++) {
    if (establishFiles[i].id == options.id) {
      if (options.type == 'number') {
        establishFiles[i].number = value;
      } else if (options.type == 'expire_date') {
        establishFiles[i].expire_date = value;
      }
      exists = true;
      break;
    }
  }
  if (exists == false) {
    let record = {
      id:options.id,
      number:0,
      expire_date:'',
      file:null,
    }
    if (options.type == 'number') {
      record.number = value;
    } else if (options.type == 'expire_date') {
      record.expire_date = value;
    }
    establishFiles.push(record);
  }
}

const showEstablishFileDialog = () => {
  establishFiles.splice(0);
  for (let i=0;i<inputEstablishFiles.value.length;i++) {
    inputEstablishFiles.value[i] = null;
  }
  isEstablishFileDialog.value = true;
}
const closeEstablishFileDialog = () => {
  isEstablishFileDialog.value = false;
}
const selectWholesalerId = ref(0);
const onChangeSelectWholesaler = (value,option) => {
  selectWholesalerId.value = value;
  listSearch();
}
const selectWholesalers = computed(() => {
  let result = [{id:0,wholesaler_name:'全ての卸'}];
  for (let i=0;i<props.pharmacyWholesalers.length;i++) {
    result.push(props.pharmacyWholesalers[i]);
  }
  return result;
})

</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_wait_list_help"
    ></help-action>
  </div>
  <div ref="headerRef" class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
    <div class="mb-2 mt-1 mr-2">
      <select-box
          :on-change="onChangeSelectWholesaler"
          :value="selectWholesalerId"
          list-field-name="wholesaler_name"
          :options="selectWholesalers"
          place-holder="発注先卸を選択"
          list-height="20em"
      ></select-box>
    </div>
    <div class="mb-2 mt-1">
      <search-box
          :search-word="searchWord"
          :on-change="onSearchWordChange"
          :on-enter="onSearchWordEnter"
          place-holder="採用品名を入力"
      ></search-box>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderWaitRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_stock_list"
      :height="listHeight + 'px'"
      :handler="handler"
      :is-checkable="true"
      :check-values="order.edit_wait_data"
      :on-check-change="onCheckChange"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        :apis="apis"
        type="is_wait"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderFields"
        :edit-transaction-status-change="editTransactionStatusChange"
        :edit-setting-complete="editSettingComplete"
      ></order-medicine-component>
    </template>
    </custom-list>
  </div>
  <div ref="submitRef" v-show="isEdited" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
    <button type="button" @click="updatePharmacyStocksTransactionStatusConfirm" class="py-2.5 px-5 m-2　text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">確認完了</button>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isEstablishFileDialog"
  width="80%"
  :close="closeEstablishFileDialog"
>
  <template v-slot:header>
    開設許可証アップロード
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <p class="text-bold text-red-700">小分け取引先の開設許可証がアップロードされていない取引先があります。<br>手元に開設許可証がある場合はアップロードしてください。</p>
    <table class="w-full">
      <tr class="border border-gray-300" v-for="establishUpload in establishUploadList" :key="establishUpload.id">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">{{ establishUpload.pharmacy_pack.to_pharmacy.pharmacy_name }}</th>
        <td class="block py-3 text-sm md:table-cell md:w-1/3 md:px-3 md:py-2">
          <input ref="inputEstablishFiles" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="file" @change="onFileUpload($event,establishUpload.id)">
        </td>
        <td class="block py-3 text-sm md:table-cell md:w-1/3 md:px-3 md:py-2">
          <text-box
            type="text"
            place-holder="開設許可証番号を入力"
            :value="establishUploadNumber(establishUpload.id)"
            :value-options="{id:establishUpload.id,type:'number'}"
            :on-change="onTextChange"
          ></text-box>
        </td>
        <td class="block py-3 text-sm md:table-cell md:w-1/3 md:px-3 md:py-2">
          <text-box
            type="date"
            place-holder="開設許可証有効期限を入力"
            :value="establishUploadExpireDate(establishUpload.id)"
            :value-options="{id:establishUpload.id,type:'expire_date'}"
            :on-change="onTextChange"
          ></text-box>
        </td>
      </tr>
    </table>
  </div>
  <div class="flex items-center flex-row">
    <div class="m-1">
      <button type="button" @click="updatePharmacyStocksTransactionStatus" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">確認完了</button>
    </div>
    <div class="m-1">
      <button type="button" @click="closeEstablishFileDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
  </template>
</modal-dialog>
</template>

